<template>
    <modal data-parent="body">
        <div slot="header">
            <button type="button" class="close" @click.prevent="closeModal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
        </div>
        <div slot="body">
            <div v-if="activeBookingsCount" class="active-bookings-error text-danger">
                There {{ verbIs }}
                <a :href="spaceBookingsLink" title="View all bookings for this location" target="_blank">{{ activeBookingsCount }}</a>
                active or upcoming {{ nounBooking }} associated with this location.
            </div>
            <div class="intro">
                <h4>Please enter a note about disabling this space</h4>
            </div>
            <form @submit.prevent="submitForm">
                <div class="form-column">
                    <div :class="{'has-error': states.errors.comment}" class="form-group">
                        <div class="form-item">
                            <textarea
                                class="form-control v2-styles"
                                placeholder="Your comment..."
                                :disabled="states.submitting"
                                v-model="formData.comment"
                            />
                        </div>
                        <ul v-if="states.errors.comment" class="list-unstyled help-block">
                            <li v-for="error in states.errors.comment" :key="error">
                                <i class="fa fa-exclamation-triangle"/> {{ error }}
                            </li>
                        </ul>
                    </div>
                    <div class="form-group">
                        <div class="form-item">
                            <input type="checkbox" data-no-style id="send_email2" value="true" v-model="formData.send_email">
                            <label for="send_email2">Send email to space owner</label>
                        </div>
                    </div>
                    <button type="submit" class="btn btn-green btn-block" :disabled="states.submitting || states.loading">
                        <template v-if="states.submitting"><i class="fa fa-circle-o-notch fa-spin"/> Disabling&hellip;</template>
                        <template v-else-if="states.loading"><i class="fa fa-circle-o-notch fa-spin"/> Checking bookings&hellip;</template>
                        <template v-else>Disable space</template>
                    </button>
                </div>
            </form>
        </div>
    </modal>
</template>

<script>
    import Modal from '../Modal';
    import ModalBase from '../ModalBase.vue';

    export default {
        name: 'disable-space-modal',

        components: {
            Modal,
        },

        mixins: [ModalBase],

        props: [
            'space',
        ],

        data() {
            return {
                formData: {
                    comment: null,
                    send_email: true,
                    from_admin: true,
                },
                states: {
                    loading: false,
                    submitting: false,
                    errors: {},
                },
                activeBookingsCount: 0,
                spaceBookingsLink: '#',
            };
        },

        computed: {
            verbIs() {
                return this.activeBookingsCount > 1 ? 'are' : 'is';
            },
            nounBooking() {
                return this.activeBookingsCount > 1 ? 'bookings' : 'booking';
            },
        },

        mounted() {
            this.$bus
                .$off('showDisableModal')
                .$on('showDisableModal', () => {
                    this.formData.comment = null;
                    this.states.errors = {};
                    this.states.submitting = false;
                    this.getActiveBookingsCount();
                    this.showModal();
                    this.spaceBookingsLink = this.$laroute.route('hatchly.bookings.index', { space_id: this.space.id });
                });
        },

        methods: {
            submitForm() {
                this.states.submitting = true;

                $.ajax({
                    type: 'POST',
                    url: this.$laroute.route('account.landlord.spaces.disable', { id: this.space.id }),
                    data: this.formData,
                    success: () => {
                        this.closeModal();
                        swal({
                            title: 'Space successfully disabled',
                            type: 'success',
                        }, () => {
                            return window.location.reload();
                        });
                    },
                    error: ({ responseJSON }) => {
                        this.states.errors = responseJSON.errors;
                    },
                    complete: () => {
                        this.states.submitting = false;
                    },
                });
            },

            getActiveBookingsCount() {
                this.states.loading = true;
                this.activeBookingsCount = null;

                $.ajax({
                    type: 'GET',
                    url: this.$laroute.route('hatchly.api.space-info.booking-count', { spaceId: this.space.id }),
                    success: (response) => {
                        this.activeBookingsCount = response.active_bookings_count;
                    },
                    error: ({ responseJSON }) => {
                        this.states.errors = responseJSON.message;
                    },
                    complete: () => {
                        this.states.loading = false;
                    },
                });
            },

            closeModal() {
                $('#disable-space-modal').modal('hide');
            },
        },
    };
</script>

<style lang="less" rel="stylesheet/less" scoped>
    @import (reference) "../../../less/variables";

    .modal {
        .modal-dialog {
            .modal-content {
                .modal-body {
                    input[type=checkbox] {
                        position: fixed;
                        left: -9999px;

                        + label {
                            font-family: @headings-font-family;
                            font-size: 15px;
                            color: #5c646b;
                            font-weight: 400;
                            display: inline-block;
                            position: relative;
                            padding-left: 32px;
                            margin-bottom: 17px;
                            opacity: 1;
                            margin-top: 8px;

                            small {
                                display: block;
                                font-size: 13px;
                            }

                            &:after {
                                content: "";
                                display: inline-block;
                                width: 21px;
                                height: 21px;
                                border-radius: 2px;
                                border: 1px solid rgba(151, 151, 151, 0.5);
                                top: 0;
                                left: 0;
                                position: absolute;
                                color: #ffffff;
                            }
                        }

                        &:checked {
                            + label {
                                &:after {
                                    background-color: @YPS-secondary;
                                    border-color: @YPS-secondary;
                                    content: '\f00c';
                                    font-family: FontAwesome;
                                    text-align: center;
                                    line-height: 21px;
                                    transition: all 0.35s ease;
                                }
                            }
                        }
                    }

                    .active-bookings-error {
                        font-weight: 500;
                        padding-bottom: 10px;
                    }
                }
            }
        }
    }
</style>
